module.exports = __webpack_public_path__ + "static/media/minsize-brandmark.90d58f92.svg";